var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionButtonTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_290_2606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 14,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18875 14.9387L6.06125 11.8113L5 12.8725L9.18875 17.0612L18.1888 8.06125L17.1275 7L9.18875 14.9387Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_290_2606)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0AC247"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonTick);
export default __webpack_public_path__ + "static/media/actionButtonTick.ce51b2b45dce506652fb25bdbfcfbb01.svg";
export { ForwardRef as ReactComponent };